import { render, staticRenderFns } from "./AccordionBlock.vue?vue&type=template&id=673db9b0"
import script from "./AccordionBlock.vue?vue&type=script&lang=ts"
export * from "./AccordionBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports